import './UserProfilePage.css';

import React from 'react';
import { Box } from '@mui/material';
import Banner from '../../b2b-common/Banner';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import UserPersonalData from '../components/user/UserPersonalData';
import UserChangePassword from '../components/user/UserChangePassword';
import UserOrganizations from '../components/user/UserOrganizations';

const UserProfilePage = () => {
    const { t } = useB2BTranslation('b2b-users');

    return (
        <Box className={'user-profile-page'} width={'100%'} height={'100%'} display={'flex'} flexDirection={'column'} gap={3} pb={12} >
            <Banner message={t('User profile')} underline={false} headingLevel='h1' />
            <Banner message={t('User information')} underline={false} headingLevel='h2' />
            <Box className={'user-info'} width={'50%'} pb={3} >
                <UserPersonalData />
            </Box>
            <Banner message={t('User organizations')} underline={false} headingLevel='h2' />
            <Box className={'user-organizations'} width={'100%'} pb={3} >
                <UserOrganizations />
            </Box>
            <Banner message={t('Change password')} underline={false} headingLevel='h2' />
            <Box className={'user-change-password'} width={'50%'} pb={3}>
                <UserChangePassword />
            </Box>
        </Box>
    );
};
export default UserProfilePage;